import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#82BB0F",
      "fill-rule": "evenodd",
      d: "M2.298 6.314L0 9.164 6.776 15 16 3.349 13.222 1 6.291 9.754z"
    }, null, -1)
  ]))]))
}
export default { render: render }